import { CompaniesModel } from '@w3lcome/types';

import RequestCreator from './BaseRequest';

const api = new RequestCreator<CompaniesModel>('/ipad/children/companies');
export default api;
